import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const getGoogleSheetsDataIngestionAppId = () => enviro.isQa() ? 15785091 : 8326827;
export function GoogleSheetsDataStudioSuccessScreen({
  authResponse,
  portalId,
  trackingSource,
  onCancel
}) {
  const appId = getGoogleSheetsDataIngestionAppId();
  if (trackingSource === 'marketplace') {
    window.location.href = `${getFullUrl('app')}/data-studio-home/${portalId}/overview?skipToAddNewExternalSource=true&appId=${appId}&accountId=${authResponse.id}`;
  } else {
    onCancel();
  }
  return /*#__PURE__*/_jsx(_Fragment, {});
}